import {Component} from 'react';
import h from 'react-hyperscript';
import './TransformationSurvey.scss';
import Intro from 'Pages/TransformationSurvey/Steps/Intro/Intro';
import BasicInfo from 'Pages/TransformationSurvey/Steps/BasicInfo/BasicInfo';
import Review from 'Pages/TransformationSurvey/Steps/Review/Review';
import SurveyElement from
  'Pages/TransformationSurvey/Steps/SurveyElement/SurveyElement';
import Messaging from 'Pages/TransformationSurvey/Steps/Messaging/Messaging';
import surveyContent from 'Assets/data/survey.json';
import FormControl from '@material-ui/core/FormControl';
import {ENDPOINTS, getAccessToken} from 'Src/utils/utils';
import {SURVEY} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
import ErrorMessage from 'Components/ErrorMessage/ErrorMessage';
import ErrorPage from 'Components/ErrorPage/ErrorPage';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
const SURVEY_VERSION = 1.5; // use release version
class TransformationSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      totalPercentComplete: 0,
      completedSteps: [],
      showRemaining: true,
      fieldValues: {
        completed: false,
      },
      questionsAnswered: 0,
      isValidUrl: false,
      isLoaded: false,
      errorMessage: null,
      submitErrorMessage: null,
      isLoadingSubmit: false,
      errorPage: undefined,
    };
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.goToStep = this.goToStep.bind(this);
    this.saveValues = this.saveValues.bind(this);
    this.saveAndContinue = this.saveAndContinue.bind(this);
    this.saveToFbx = this.saveToFbx.bind(this);
    this.saveFormtoDb = this.saveFormtoDb.bind(this);
    this.totalQuestions = 1; // For the priority question in review section
    surveyContent.formStepsOverview.forEach((step) => {
      if (
        surveyContent[step.id].questions &&
        surveyContent[step.id].questions.length
      ) {
        this.totalQuestions += surveyContent[step.id].questions.length;
        if (surveyContent[step.id].elementPriorities) {
          this.totalQuestions += 1;
        }
      }
    });
  }

  componentDidMount() {
    this.validateSurveySlug();
    this.checkSurveyState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.userStatus !== prevProps.userStatus) {
      this.checkSurveyState();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.resubmitTimeout);
  }

  validateSurveySlug() {
    const idToken = this.props.googleUser.getAuthResponse().id_token;
    const href = window.location.href;
    const slug = href.split('/').pop();

    return fetch(ENDPOINTS.SURVEY_SLUG, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        url_randomizer: slug,
        access_token: getAccessToken(this.props.googleUser),
      }),
    })
        .then((response) => {
          if (response.status === 200) {
            this.setIsValidUrl(true);
          } else {
            this.setIsValidUrl(false);
          }
          return response.json();
        })
        .then((result) => {
          if (result.message === 'User is not part of valid EDU') {
            this.setState({
              errorPage: 'nonEdu',
            });
          } else if (result.message) {
            this.setErrorMessage(result.message);
          }
          this.setState({
            isLoaded: true,
          });
        });
  }

  setIsValidUrl(value) {
    this.setState({
      isValidUrl: value,
    });
  }

  setErrorMessage(value) {
    this.setState({
      errorMessage: value,
    });
  }

  setSubmitErrorMessage(value) {
    this.setState({
      submitErrorMessage: value,
      isLoadingSubmit: false,
    });
  }

  checkSurveyState() {
    if (this.props.userStatus.user_survey_state === 'Complete' ||
      !this.props.userStatus.survey_open_period_flag) {
      this.goToStep(surveyContent.formStepsOverview.length - 1);
    }
    this.getValuesFromDb();
  }

  nextStep() {
    this.goToStep(this.state.activeStep + 1);
  }

  prevStep() {
    this.goToStep(this.state.activeStep - 1);
  }

  goToStep(step) {
    this.setState(
        (state, props) => ({
          activeStep: step,
        }),
        () => {
          this.scrollToTop();
        }
    );
  }

  scrollToTop() {
    const scrollStep = -window.scrollY / (100 / 15);
    const scrollInterval = setInterval(() => {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep);
      } else clearInterval(scrollInterval);
    }, 15);
  }

  calculateTotalPercentComplete(jumpToLatestStep, cb) {
    const totalFormSteps = surveyContent.sidebarItems.length;
    const completedSteps = [];
    const lastStepPercentage = totalFormSteps - 1 / totalFormSteps;
    const showValidationPercentage = totalFormSteps - 1 / 2;
    let questionsAnswered = 0;
    surveyContent.sidebarItems.forEach((formScreen, i) => {
      const id = `${formScreen.id.split('__')[1]}Values`;
      const values = this.state.fieldValues[id];
      if (values && values.elementComplete) {
        questionsAnswered += values.elementComplete.answered;
      }

      if (id !== 'review') {
        if (
          values &&
          values.elementComplete &&
          values.elementComplete.percentage === 1
        ) {
          if (!completedSteps.includes(id)) {
            completedSteps.push(id);
          }
        }
      }
    });
    if (jumpToLatestStep && completedSteps.length) {
      // Cap out at 9th step so you don't see results
      // screen if you've completed review but not yet submit
      this.goToStep(Math.min(completedSteps.length + 1, 9));
    }
    this.setState(
        {
          completedSteps: completedSteps,
          questionsAnswered: questionsAnswered,
          totalPercentComplete: questionsAnswered / this.totalQuestions,
        },
        () => {
          if (this.state.totalPercentComplete === 1) {
            this.setIsSurveyComplete(true);
          }
          if (this.state.totalPercentComplete > showValidationPercentage &&
          this.state.totalPercentComplete < lastStepPercentage) {
            this.setShowRemaining(true);
          }
          if (typeof cb === 'function') cb();
        }
    );
  }

  saveAndContinue(data, elementState, doSubmitToFBX) {
    if (doSubmitToFBX) {
      this.saveValues(data, elementState, true, doSubmitToFBX);
    } else {
      this.saveValues(data, elementState, true);
      this.nextStep();
    }
  }

  saveValues(data, elementState, sendToDb, doSubmitToFBX) {
    this.setState(
        {
          fieldValues: {
            ...this.state.fieldValues,
            [elementState]: data,
          },
        },
        () => {
          let saveFormtoDb;

          if (sendToDb) {
            const cb = doSubmitToFBX ? this.saveToFbx : null;
            const num = doSubmitToFBX ? 3 : 0;
            saveFormtoDb = this.saveFormtoDb.bind(this, cb, num);
          }

          this.calculateTotalPercentComplete(false, saveFormtoDb);
        }
    );
  }

  setIsSurveyComplete(value) {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        completed: value,
      },
    });
  }

  setShowRemaining(value) {
    this.setState({
      showRemaining: value,
    });
  }

  refreshToken() {
    return fetch(ENDPOINTS.USER_STATUS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': this.props.googleUser.getAuthResponse().id_token,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        access_token: this.props.googleUser.getAuthResponse().access_token,
      }),
    }).then(
        (res) => {
          return true;
        },
        (error) => {
          console.log('token err:', error);
          this.setSubmitErrorMessage(
              'Something went wrong. Please try again later.'
          );
        }
    );
  }

  saveFormtoDb(cb, retries) {
    if (cb) {
      this.setState({isLoadingSubmit: true, submitErrorMessage: null});
    }

    let data = {...this.state.fieldValues, version: SURVEY_VERSION};
    if (!cb) {
      // if !cb...i.e. not submittingToFBX, don't mark the survey
      // as complete even though complete so they can come back and submit
      data = {...data, completed: false, activeStep: this.state.activeStep};
    }
    fetch(ENDPOINTS.SUBMIT_SURVEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        data,
        access_token: getAccessToken(this.props.googleUser),
      }),
    })
        .then((response) => {
          if (response.status === 402) {
            return this.refreshToken(this.saveFormtoDb.bind(this, cb, retries));
          } else {
            return response.json();
          }
        })
        .then(
            (res) => {
              if (res.success) {
                if (cb) {
                  cb();
                }
              } else if (retries) {
                this.resubmitTimeout = window.setTimeout(() => {
                  this.saveFormtoDb(cb, retries - 1);
                }, 1000);
              } else {
                // Edge case debugging for unsuccessful submit
                console.log('Response: ', res);
                this.setSubmitErrorMessage(
                    'Something went wrong. Please try again later.'
                );
              }
            },
            (error) => {
              if (retries) {
                this.resubmitTimeout = window.setTimeout(() => {
                  this.saveFormtoDb(cb, retries - 1);
                }, 1000);
              } else {
                this.setSubmitErrorMessage(
                    'Something went wrong. Please try again later.'
                );
              }
              console.log('Submit Error: ', error);
            }
        );
  }

  getValuesFromDb(jumpToLatestStep, retries = 2) {
    fetch(ENDPOINTS.SURVEY_RESPONSES, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        access_token: getAccessToken(this.props.googleUser),
      }),
    })
        .then(
            (response) => {
              if (response.status !== 200) {
                if (retries) {
                  this.getValuesFromDb(jumpToLatestStep, retries - 1);
                }
                return;
              }
              return response.json();
            },
            (error) => {
              if (retries) {
                this.getValuesFromDb(jumpToLatestStep, retries - 1);
              }
              console.log('Retrieve data Error: ', error);
            }
        )
        .then((result) => {
          if (result && result.survey_responses) {
            if (this.hasValidDbData(result.survey_responses)) {
              this.setFieldValuesFromDB(
                  result.survey_responses,
                  jumpToLatestStep
              );
            }
          }
        });
  }

  hasValidPriorityCheckboxes(data, key) {
    const titles = surveyContent[key].questions.map((item) => {
      return item.title;
    });
    const cbValues = data.map((cbData) => {
      return cbData.value;
    });
    const isUnique = cbValues.length === new Set(cbValues).size;
    const invalidCheckbox =
      !isUnique ||
      cbValues.find((value) => {
        return titles.indexOf(value) === -1;
      });
    return !invalidCheckbox;
  }

  hasValidDbData(data) {
    const standardKeys = [
      'vision',
      'learningApproach',
      'culture',
      'professionalDevelopment',
      'technology',
      'communityEngagement',
      'fundingSustainability',
    ];
    const basicInfoKey = 'basicInfoValues';
    const reviewKey = 'reviewValues';
    const validData = {};
    let hasValidDbData = true;
    for (let i = 0; i < standardKeys.length; i++) {
      const dataItem = data[`${standardKeys[i]}Values`];
      if (dataItem) {
        // Check if data has valid saved radio question responses
        const validQuestionIds = surveyContent[standardKeys[i]].questions
            .map((item) => {
              return item.id;
            });
        const validProgressItems = dataItem.surveyValues.progress
            .filter((item) => {
              return validQuestionIds.indexOf(item.name) >= 0;
            });
        const hasValidProgress =
          validProgressItems.length === dataItem.surveyValues.progress.length;

        // Check if data has valid checkbox answers
        const hasValidCheckboxes =
          dataItem.surveyValues.priorityCheckboxes &&
          dataItem.surveyValues.priorityCheckboxes.length &&
          this.hasValidPriorityCheckboxes(
              dataItem.surveyValues.priorityCheckboxes,
              standardKeys[i]
          );

        // Calculate actual number of questions answered from valid progress
        // and valid checkboxes
        let actualAnswered = validProgressItems.length;
        if (
          dataItem.surveyValues.priorityCheckboxes &&
          dataItem.surveyValues.priorityCheckboxes.length > 0 &&
          dataItem.surveyValues.priorityCheckboxes.length < 4 &&
          hasValidCheckboxes
        ) {
          actualAnswered++;
        }
        // Check if actualAnsewered does not match or if invalid
        // checkboxes/answers and overwrite data if so
        if (actualAnswered !== dataItem.elementComplete.answered ||
            !hasValidCheckboxes || !hasValidProgress) {
          const sectionValues = {...dataItem};
          const extraQuestion =
            surveyContent[standardKeys[i]].elementPriorities ? 1 : 0;
          sectionValues.elementComplete.total =
            surveyContent[standardKeys[i]].questions.length + extraQuestion;
          sectionValues.elementComplete.answered = actualAnswered;
          sectionValues.elementComplete.remaining =
            sectionValues.elementComplete.total - actualAnswered;
          sectionValues.elementComplete.percentage = actualAnswered /
            sectionValues.elementComplete.total;
          sectionValues.surveyValues.progress = validProgressItems ?
            validProgressItems : [];

          if (!hasValidCheckboxes) {
            sectionValues.surveyValues.priorityCheckboxes = [];
          }
          validData[`${standardKeys[i]}Values`] = sectionValues;
          hasValidDbData = false;
        } else {
          validData[`${standardKeys[i]}Values`] = dataItem;
        }
      }
    }
    // Validate basicInfo data
    if (data[basicInfoKey]) {
      const actualBasicInfoAnswers =
        this.checkBasicInfoAnswers(data[basicInfoKey]);
      if (
        actualBasicInfoAnswers !== data[basicInfoKey].elementComplete.answered
      ) {
        const basicInfoValues = {...data[basicInfoKey]};
        basicInfoValues.elementComplete.answered = actualBasicInfoAnswers;
        basicInfoValues.elementComplete.remaining =
          basicInfoValues.elementComplete.total - actualBasicInfoAnswers;
        basicInfoValues.elementComplete.percentage = actualBasicInfoAnswers /
          basicInfoValues.elementComplete.total;
        if (!this.checkDataTitleExists(basicInfoValues.surveyValues.title)) {
          basicInfoValues.surveyValues.title = '';
        }
        validData[basicInfoKey] = basicInfoValues;
        hasValidDbData = false;
      } else {
        validData[basicInfoKey] = data[basicInfoKey];
      }
    }
    // Validate review data
    if (data[reviewKey] &&
      data[reviewKey].surveyValues &&
      data[reviewKey].surveyValues.priority &&
      data[reviewKey].surveyValues.priority.value) {
      if (data[reviewKey].elementComplete.answered !== 1) {
        const reviewValues = {...data[reviewKey]};
        reviewValues.elementComplete.total = 1;
        reviewValues.elementComplete.answered = 1;
        reviewValues.elementComplete.remaining = 0;
        reviewValues.elementComplete.percentage = 1;
        validData[reviewKey] = reviewValues;
        hasValidDbData = false;
      } else {
        validData[reviewKey] = data[reviewKey];
      }
    }

    if (hasValidDbData) {
      return true;
    } else {
      this.setState({fieldValues: data}, () => {
        this.saveFormtoDb();
        this.calculateTotalPercentComplete();
      });
      return false;
    }
  }

  checkDataTitleExists(title) {
    return surveyContent.basicInfo.questions[1].options.find((item) => {
      return item.title === title;
    });
  }

  checkBasicInfoAnswers(data) {
    let actualAnswered = 0;
    const keys = ['name', 'email', 'districtName'];
    for (let i = 0; i < keys.length; i++) {
      if (data.surveyValues[keys[i]]) {
        actualAnswered++;
      }
    }
    if (this.checkDataTitleExists(data.surveyValues.title)) {
      actualAnswered++;
    }
    return actualAnswered;
  }

  setFieldValuesFromDB(data, jumpToLatestStep) {
    this.setState(
        {
          fieldValues: {...this.state.fieldValues, ...data},
        },
        () => {
          this.calculateTotalPercentComplete(jumpToLatestStep);
        }
    );
  }

  saveToFbx(retries = 3) {
    const fieldValues = this.state.fieldValues;
    const {name, email, title, districtName} =
      fieldValues.basicInfoValues.surveyValues;
    const data = this.serialize(fieldValues);

    fetch(ENDPOINTS.FBX, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
    })
        .then((response) => response.json())
        .then(
            (res) => {
              if (typeof res === 'object' && res.result === 'accepted') {
                pushGTMEvent(SURVEY.TAG, {
                  event: SURVEY.EVENT,
                  action: {survey_action: SURVEY.ACTION.SUBMIT},
                  variables: {
                    survey_applicant_first_name: name,
                    survey_applicant_title: title,
                    survey_applicant_email: email,
                    survey_applicant_district_name: districtName,
                  },
                });
                this.props.fetchUserStatus();
                this.setState({isLoadingSubmit: false});
              } else {
                if (retries) {
                  this.resubmitTimeout = window.setTimeout(() => {
                    this.saveToFbx(retries - 1);
                  }, 1000);
                } else {
                  this.setSubmitErrorMessage(
                      'Something went wrong. Please try again later.'
                  );
                }
              }
            },
            (error) => {
              if (retries) {
                this.resubmitTimeout = window.setTimeout(() => {
                  this.saveToFbx(retries - 1);
                }, 1000);
              } else {
                this.setSubmitErrorMessage(
                    'Something went wrong. Please try again later.'
                );
              }
              console.log('Error: ', error);
            }
        );
  }

  serialize(data) {
    const values = [];
    const elements = surveyContent.formStepsOverview.slice(0);
    // eslint-disable-next-line
    const newEls = elements.splice(0, 2);
    elements.pop();
    elements.pop();

    if (data.basicInfoValues && data.basicInfoValues.surveyValues) {
      const keys = Object.keys(data.basicInfoValues.surveyValues);
      keys.forEach((key) => {
        const value = data.basicInfoValues.surveyValues[key];
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value);
        const encodedVals = `${encodedKey}=${encodedValue}`;
        values.push(encodedVals);
      });
    }

    if (data.reviewValues && data.reviewValues.surveyValues) {
      if (data.reviewValues.surveyValues.comments) {
        const commentRaw = data.reviewValues.surveyValues.comments;
        const comment = encodeURIComponent(commentRaw);
        const encodedCommentVals = `comments=${comment}`;
        values.push(encodedCommentVals);
      }
      const priorityRaw = data.reviewValues.surveyValues.priority.value;
      const priority = encodeURIComponent(priorityRaw);
      const encodedPriorityVals = `elementpriority=${priority}`;
      values.push(encodedPriorityVals);
    }

    elements.forEach((element) => {
      const id = `${element.id}Values`;
      const checkboxKey = `${element.id.toLowerCase()}priority`;
      if (data[id] && data[id].surveyValues) {
        const progressArray = data[id].surveyValues.progress;
        const checkboxArray = data[id].surveyValues.priorityCheckboxes;

        progressArray.forEach((item) => {
          const encodedKey = encodeURIComponent(item.name);
          const encodedValue = encodeURIComponent(item.value);
          const encodedProgress = `${encodedKey}=${encodedValue}`;
          values.push(encodedProgress);
        });

        checkboxArray.forEach((item) => {
          const encodedValue = encodeURIComponent(item.value);
          const encodedPriorities = `${checkboxKey}=${encodedValue}`;
          values.push(encodedPriorities);
        });
      }
    });
    return values.join('&').replace(/%20/g, '+');
  }
  render() {
    if (this.state.isLoaded) {
      if (this.state.isValidUrl) {
        const {dynamicGraphSize, screenWidth} = this.props;

        const activeStep = surveyContent
            .formStepsOverview[this.state.activeStep];

        const activeStepId = activeStep.id;
        const attributes = {
          key: `${activeStepId}-main-content__key`,
          id: `${activeStepId}--screen`,
          step: activeStepId,
          content: {
            ...surveyContent[activeStepId],
            buttons: surveyContent.buttons,
            elementDisclaimer: surveyContent.elementDisclaimer,
          },
          transformationElements: surveyContent.transformationElements,
          fieldValues: this.state.fieldValues,
          showRemaining: this.state.showRemaining,
          nextStep: this.nextStep,
          prevStep: this.prevStep,
          goToStep: this.goToStep,
          saveValues: this.saveValues,
          activeStep: activeStepId,
          saveAndContinue: this.saveAndContinue,
          logoutClick: this.props.logoutClick,
          districtName: this.props.userStatus.district_name,
          className: surveyContent[activeStepId].classes,
          sidebarItems: surveyContent.sidebarItems,
          hasSidebar: surveyContent[activeStepId].hasSidebar,
          completedSteps: this.state.completedSteps,
          totalPercentComplete: this.state.totalPercentComplete,
          showSectionProgress: surveyContent[activeStepId].showSectionProgress,
          googleUser: this.props.googleUser,
          userStatus: this.props.userStatus,
          idToken: this.props.idToken,
          csrf: this.props.csrf,
          errorMessage: this.state.errorMessage,
          dynamicGraphSize,
          screenWidth,
          isLoadingSubmit: this.state.isLoadingSubmit,
          submitErrorMessage: this.state.submitErrorMessage,
        };

        switch (activeStepId) {
          case 'intro':
            return h(
                FormControl,
                {
                  className: 'page-content',
                  id: `page-content__survey`,
                },
                h(Intro, attributes, null)
            );
          case 'basicInfo':
            return h(
                FormControl,
                {
                  className: 'page-content',
                  id: `page-content__survey`,
                },
                h(BasicInfo, attributes, null)
            );
          case 'review':
            return h(
                FormControl,
                {
                  className: 'page-content',
                  id: `page-content__survey`,
                },
                h(Review, attributes, null)
            );
          case 'complete':
            return h(
                FormControl,
                {
                  className: 'page-content',
                  id: `page-content__survey`,
                },
                h(Messaging, attributes, null)
            );
          default:
            return h(
                FormControl,
                {
                  className: 'page-content',
                  id: `page-content__survey`,
                },
                h(SurveyElement, attributes, null)
            );
        }
      } else {
        return this.state.errorPage ?
        h(ErrorPage, {
          errorType: this.state.errorPage,
        }) : h(
            ErrorMessage,
            {
              message: this.state.errorMessage,
            },
            null
        );
      }
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default TransformationSurvey;
